<div class="ml-auto w-full md:w-91 px-8 py-10 bg-primary bg-opacity-8 rounded-b-lg">
  @for (item of properties | keyvalue:compareFn; track item; let last = $last) {
    @if (propertyNames[item.key]) {
      <div class="font-medium" [class.mb-4]="!last">
        <span class="text-sm text-neutral-1">{{ propertyNames[item.key] }}</span>
        <h2 class="text-lg m-0">
          @switch (propertyStyle[item.key]) {
            @case ('date') {
              {{ (item.value|date:"dd-MM-yyyy") || '-' }}
            }
            @default {
              {{ item.value || '-' }}
            }
          }
        </h2>
      </div>
    }
  }
</div>
